module.exports = __webpack_public_path__ + "media/images/locations/india-8f82e94d9c99d0c90fd455b3fb3360bb.jpg";